import {Component, Input, OnInit} from '@angular/core';
import {ApprovalModel} from '../../shared/dto/approval.model';
import Swal, {default as swal} from 'sweetalert2';
import {ApprovalService} from '../../service/approval.service';
import {FormControl, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
  selector: 'app-fwd-remark',
  templateUrl: './fwd-remark.component.html',
  styleUrls: ['./fwd-remark.component.scss']
})
export class FwdRemarkComponent implements OnInit {
  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  applicantType:string;


  constructor(private approvalService: ApprovalService, private router: Router) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.applicantType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to forward the request?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.forwardtoDg(this.approvalModel).subscribe(
          (success: string) => {
            swal.fire('Success', 'Applicant Details Updated', 'success');
            this.router.navigate(['/dashboard/approval-pending', this.applicantType] );
            this.approvalService.close();
          },
          (error) => {
            swal.fire('Error', 'Error When Updating the Request', 'error');
          },
        );
      } else {
      }
    });
  }

}
